import React, { useEffect, useState } from "react";
import "./../css/probe.scss";
import { useLanguage } from "../context/LanguageContext";

const Probe: React.FC<{ option?: string; blockingAction?: () => void; unblockingAction?: () => void }> = ({
  option,
  blockingAction,
  unblockingAction,
}) => {
  const { lang } = useLanguage();
  const [logs, setLogs] = useState<string[]>([]);

  useEffect(() => {
    if (blockingAction) blockingAction();

    const conn = (navigator as any).connection;
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const es = lang === "es";

    const sequence: { msg: string; delay: number }[] = [
      { msg: `> ${es ? "SONDEANDO TU DISPOSITIVO..." : "PROBING YOUR DEVICE..."}`, delay: 0 },
      { msg: `> USER_AGENT: ${navigator.userAgent}`, delay: 500 },
      { msg: `> ${es ? "PLATAFORMA" : "PLATFORM"}: ${navigator.platform || "unknown"}`, delay: 900 },
      { msg: `> ${es ? "IDIOMA" : "LANGUAGE"}: ${navigator.language}`, delay: 1300 },
      { msg: `> ${es ? "RESOLUCIÓN" : "RESOLUTION"}: ${window.screen.width}x${window.screen.height}`, delay: 1700 },
      { msg: `> ${es ? "ZONA HORARIA" : "TIMEZONE"}: ${tz}`, delay: 2100 },
      { msg: `> ${es ? "CONEXIÓN" : "CONNECTION"}: ${conn?.effectiveType || "desconocida/unknown"}`, delay: 2500 },
      {
        msg: `> ${es
          ? "CONCLUSIÓN: eres un libro abierto para cualquier sitio. Cuida lo que compartes."
          : "CONCLUSION: you're an open book to any site. Watch what you share."}`,
        delay: 3000,
      },
      { msg: `> ${es ? "PROBE COMPLETO." : "PROBE COMPLETE."}`, delay: 3600 },
    ];

    sequence.forEach((step, i) => {
      setTimeout(() => {
        setLogs((prev) => [...prev, step.msg]);
        if (i === sequence.length - 1 && unblockingAction) {
          unblockingAction();
        }
      }, step.delay);
    });
  }, [blockingAction, unblockingAction, lang]);

  return (
    <div className="probe-container">
      <div className="probe-log">
        {logs.map((log, i) => (
          <div key={i} className="probe-item">{log}</div>
        ))}
      </div>
    </div>
  );
};

export default Probe;
